import Route from "@ember/routing/route";
import { service } from "@ember/service";

export default class FileStorageVolumesRoute extends Route {
  @service availableServices;

  beforeModel() {
    this.availableServices.requireAccessTo(this, "storage");
  }
}
